<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-input v-model="model.PartnerCode" type="text" 
                                     label="Partner Code *" 
                                     autofocus 
                                      
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('PartnerCode')"
                                     :error-message="fieldErrorMessage('PartnerCode')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.ApiKey" type="text" 
                                     label="API Key *" 
                                      
                                      
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('ApiKey')"
                                     :error-message="fieldErrorMessage('ApiKey')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.ApiSecret" type="text" 
                                     label="API Secret *" 
                                      
                                      
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('ApiSecret')"
                                     :error-message="fieldErrorMessage('ApiSecret')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-select v-model="model.Role" 
                                      label="Security Group *" 
                                       
                                       
                                      :options="dataSourceLookupThreePLAuthGroups" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[val => !!val || 'Required',]"
                                      :error="fieldHasError('Role')"
                                      :error-message="fieldErrorMessage('Role')"
                                      
                                      @input="onRoleChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.ThreePLGuid" type="text" 
                                     label="3PL Guid" 
                                      
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('ThreePLGuid')"
                                     :error-message="fieldErrorMessage('ThreePLGuid')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.ThreePLKey" type="text" 
                                     label="3PL Key *" 
                                      
                                      
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('ThreePLKey')"
                                     :error-message="fieldErrorMessage('ThreePLKey')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.ThreePLSecret" type="text" 
                                     label="3PL Secret *" 
                                      
                                      
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('ThreePLSecret')"
                                     :error-message="fieldErrorMessage('ThreePLSecret')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-datetime-picker v-model="model.ActiveStartDate"  mode="date" minimal
                                               label="Start Date" 
                                                
                                                
                                               :rules="[]"
                                               :error="fieldHasError('ActiveStartDate')"
                                               :error-message="fieldErrorMessage('ActiveStartDate')"
                                               
                                               
                                               dense>
                                
                                
                            </q-datetime-picker>
                        </div>
<div class="col-6" >
                            <q-datetime-picker v-model="model.ActiveEndDate"  mode="date" minimal
                                               label="End Date" 
                                                
                                                
                                               :rules="[]"
                                               :error="fieldHasError('ActiveEndDate')"
                                               :error-message="fieldErrorMessage('ActiveEndDate')"
                                               
                                               
                                               dense>
                                
                                
                            </q-datetime-picker>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.MaxSessions" type="number" 
                                     label="Max sessions" 
                                      
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('MaxSessions')"
                                     :error-message="fieldErrorMessage('MaxSessions')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-checkbox v-model="model.IsTest" 
                                        label="Is Test" 
                                         
                                        
                                        
                                        dense>
                                
                                
                            </q-checkbox>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './threeplauthaddeditmodel-dialog-screen.js'
</script>